// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResumoArtigo_resumoArtigo__iVw8Q {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
    width: 100%;

    position: relative;

    cursor: pointer;

}

.ResumoArtigo_resumoArtigo__iVw8Q:hover {
    background-color: #f9f9f9;
}

.ResumoArtigo_resumoArtigo__iVw8Q .ResumoArtigo_titulo__\\+mcmr {
    font-size: 1.5rem;
    margin: 0 0 10px;

    position: relative;
}

.ResumoArtigo_resumoArtigo__iVw8Q .ResumoArtigo_titulo__\\+mcmr::after {
    content: '';
    width: 0;
    height: 3px;

    position: absolute;
    bottom: -5px;
    left: 0;

    transition: 500ms width;

    background-color: #fff;
}

.ResumoArtigo_resumoArtigo__iVw8Q p {
    font-size: 1rem;
    margin: 0 0 20px;
}

.ResumoArtigo_resumoArtigo__iVw8Q:hover .ResumoArtigo_titulo__\\+mcmr::after {
    width: 100%;
    background-color: var(--gold-color);
}

.ResumoArtigo_data__wgSaU {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 0.8rem;
    color: #666;
}

.ResumoArtigo_author__C9pmc {
    position: absolute;
    bottom: 20px;
    right: 20px;
    font-size: 0.8rem;
    color: #666;
    font-style: italic;
    font-weight: 400;
}

`, "",{"version":3,"sources":["webpack://./src/utils/components/resumoArtigo/ResumoArtigo.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;;IAEX,kBAAkB;;IAElB,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;;IAEhB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,WAAW;;IAEX,kBAAkB;IAClB,YAAY;IACZ,OAAO;;IAEP,uBAAuB;;IAEvB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".resumoArtigo {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 20px;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);\n    width: 100%;\n\n    position: relative;\n\n    cursor: pointer;\n\n}\n\n.resumoArtigo:hover {\n    background-color: #f9f9f9;\n}\n\n.resumoArtigo .titulo {\n    font-size: 1.5rem;\n    margin: 0 0 10px;\n\n    position: relative;\n}\n\n.resumoArtigo .titulo::after {\n    content: '';\n    width: 0;\n    height: 3px;\n\n    position: absolute;\n    bottom: -5px;\n    left: 0;\n\n    transition: 500ms width;\n\n    background-color: #fff;\n}\n\n.resumoArtigo p {\n    font-size: 1rem;\n    margin: 0 0 20px;\n}\n\n.resumoArtigo:hover .titulo::after {\n    width: 100%;\n    background-color: var(--gold-color);\n}\n\n.data {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    font-size: 0.8rem;\n    color: #666;\n}\n\n.author {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n    font-size: 0.8rem;\n    color: #666;\n    font-style: italic;\n    font-weight: 400;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resumoArtigo": `ResumoArtigo_resumoArtigo__iVw8Q`,
	"titulo": `ResumoArtigo_titulo__+mcmr`,
	"data": `ResumoArtigo_data__wgSaU`,
	"author": `ResumoArtigo_author__C9pmc`
};
export default ___CSS_LOADER_EXPORT___;
